import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Sede from '@/views/Sede.vue'
import Servicos from '@/views/Servicos.vue'
import Clientes from '@/views/Clientes.vue'
import Contato from '@/views/Contato.vue'
import AboutView from '../views/AboutView.vue'
import Qualidade from '@/views/Qualidade.vue'
import Inspe from '@/views/Inspe.vue'
import Equipamentos from '@/views/Equipamentos.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/sobre',
    name: 'sobre',
    component: AboutView
  },
  {
    path: '/sede',
    name: 'sede',
    component: Sede
  },
  {
    path: '/servicos',
    name: 'servicos',
    component: Servicos
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: Clientes
  },
  {
    path: '/contato',
    name: 'contato',
    component: Contato
  },
  {
    path: '/qualidade',
    name: 'qualidade',
    component: Qualidade
  },
  {
    path: '/inspe',
    name: 'inspe',
    component: Inspe
  },
  {
    path: '/equipamentos',
    name: 'Equipamentos',
    component: Equipamentos
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
